<template>
  <div id="grid-capacitacion">
    <v-layout>
      <v-flex xs12>
        <div v-if="loading">
          <loading></loading>
        </div>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 md12>
        <v-widget
          class="px-0"
          :key="indexChart"
          :title="tituloGrafica"
          content-bg="white"
        >
          <div slot="widget-content">
            <e-chart
              :path-option="[
                ['dataset.source', res],
                [
                  'color',
                  [color.lightBlue.base, color.orange.base, color.grey.base],
                ],
                ['legend.show', true],
                ['xAxis.axisLabel.show', true],
                ['yAxis.axisLabel.show', true],
                ['grid.left', '2%'],
                ['grid.bottom', '5%'],
                ['grid.right', '3%'],
                ['series[0].type', 'bar'],
                ['series[0].areaStyle', {}],
                ['series[0].smooth', true],
                ['series[1].type', 'bar'],
                ['series[1].areaStyle', {}],
                ['series[1].smooth', true],
                ['series[2].type', 'bar'],
                ['series[2].areaStyle', {}],
                ['series[2].smooth', true],
              ]"
              height="400px"
              width="100%"
            ></e-chart>
          </div>
        </v-widget>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import EChart from "@/components/chart/echart";
import VWidget from "@/components/VWidget";
import Material from "vuetify/es5/util/colors";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";

export default {
  components: {
    VWidget,
    EChart,
    CircleStatistic,
    Loading,
    AlertEmpty,
  },
  mixins: [misMixins],
  data: () => ({
    show: false,
    loading: false,
    showAlert: false,
    color: Material,
    contratoId: "",
    selectedTab: "tab-1",
    pruebas: [],
    res: "",
    indexChart: 0,
    subProceso: "",
    tituloGrafica: "",
    btnHidden: true,
    botonHidden: false,
  }),
  computed: {},
  props: {
    dataGrafica: [],
  },
  created() {
    this.contratoId = this.$store.getters.contratoStored;
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.tituloGrafica = "Documento Nivel " + this.dataGrafica.nivel;
    this.chartData();
  },
  mounted() {},
  methods: {
    chartData() {
      let data = [];
      this.dataGrafica.lstDocumentos.forEach((m) => {
        data.push({
          documento: m.documento,
          Capturado: m.capturado,
          Pendiente: m.pendiente,
          // "Porcentaje Capturado" : m.porc_capturado,
          // "Porcentaje Pendiente" : m.porc_pendiente,
          "Total Capturar": m.total_capturar,
        });

        //console.log("stringify:" + JSON.stringify(data, null, 2));
        this.indexChart += 1;
      });
      this.res = data;
    },
  },
};
</script>
